export default __webpack_public_path__ + "static/media/automation_of_documentation_original.e4b95295.png";